function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.33706 10.2591C5.89706 7.91607 6.44406 5.56907 7.02206 3.23107C7.40506 1.68507 8.03206 1.26007 9.55306 1.62207C12.6901 2.37007 15.8191 3.16507 18.9431 3.97107C20.2701 4.31507 20.7191 5.06507 20.4031 6.40907C19.2601 11.2651 18.1011 16.1151 16.9251 20.9621C16.6141 22.2421 15.8861 22.7151 14.6281 22.4131C11.3711 21.6281 8.12206 20.8111 4.87706 19.9721C3.67206 19.6601 3.29206 18.9131 3.60606 17.5381C4.16306 15.1061 4.75906 12.6851 5.33706 10.2591Z",
  fill: "#F5F500"
});

var SvgYellowCard = function SvgYellowCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellowCard.202070c1.svg";
export { ForwardRef as ReactComponent };